import { gql } from '@apollo/client'

import { EVENT_FRAGMENT } from '../../../common/graphql/fragments'

import { CUISINE_TYPE_NODE_FRAGMENT } from '../fragments'

const SAVE_CUISINE_TYPES_MUTATION = gql`
  mutation saveCuisineTypes($data: [CuisineTypeNodeInput!]!) {
    saveCuisineTypes(data: $data) {
      results {
        ...CuisineTypeNodeFragment
      }
      latestEvent {
        ...EventFragment
      }
    }
  }
  ${CUISINE_TYPE_NODE_FRAGMENT}
  ${EVENT_FRAGMENT}
`

export default SAVE_CUISINE_TYPES_MUTATION
